import React from 'react';

interface FormBlockProps {
  children: React.ReactNode;
}

export const FormBlock: React.FC<FormBlockProps> = ({ children }) => {
  return <div className='sg-u-box sg-a-p-2 sg-u-vs-2'>{children}</div>;
};
